import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getConfig, setConfig } from '../../configuracao/configLocal';
import { getConfControladorGrupoPluviometroList } from './selectdbAtions';

class SelectConfControladorPluviometroHistorico extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: getConfig('cont'),
    };
  }

  componentDidMount() {
    this.props.getConfControladorGrupoPluviometroList();
  }

  renderOptions() {
    const list = this.props.listPluviometro || [];
    const anel = this.props.anel !== false;

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    let listCont = [];
    let firstAnel = null;

    list.forEach(cont => {
      //se não exibe aneis então ajusta o valor selecionado
      if (!anel) {
        if (cont.anel === 1) {
          firstAnel = cont.id;
          listCont.push(cont); // Só adiciona controladores do anel 1
        } else if (cont.id === +this.state.value) {
          setConfig('cont', firstAnel);
          this.setState({ value: firstAnel });
        }
      } else {
        listCont.push(cont); // Se exibe anéis, adiciona todos
      }
    });

    return listCont.map(contro => (
      <option
        key={contro.id}
        value={contro.id}
        data-numcont={contro.numero_controlador}
        data-anel={contro.anel}
        data-ip={contro.ip}
        data-porta={contro.porta}
      >
        {`${contro.numero_controlador} - ${contro.endereco}`}
        {anel && ` - Anel ${contro.anel}`}
      </option>
    ));
  }

  handleChange(event) {
    const selectedOption = event.target.options[event.target.selectedIndex];
    const numCont = selectedOption.getAttribute('data-numcont');
    const anel = selectedOption.getAttribute('data-anel');
    const ip = selectedOption.getAttribute('data-ip');
    const porta = selectedOption.getAttribute('data-porta');

    this.setState({ value: event.target.value });
    setConfig('cont', event.target.value);
    setConfig('numCont', numCont);
    setConfig('anel', anel);
    setConfig('ip', ip);
    setConfig('porta', porta);

    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }

  render() {
    const defaultStyle = { width: '300px', display: 'inline', marginLeft: '8px' };
    const finalStyle = this.props.customStyle ? this.props.customStyle : defaultStyle;

    return (
      <div style={{ marginTop: '0px' }}>
        <select
          id={'selectConfControlador'}
          name={'selectConfControlador'}
          style={finalStyle}
          className={this.props.customStyle ? '' : 'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="todos" style={{ fontWeight: 'bold', color: '#007bff' }}>
            Todos
          </option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ listPluviometro: state.selectdb.listControladorPluviometro });
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getConfControladorGrupoPluviometroList,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectConfControladorPluviometroHistorico);
